import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (admin === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <span className="overline text-muted-foreground">Loading…</span>
      </div>
    );
  }
  if (!admin) return <Navigate to="/login" replace />;
  return children;
};
